import './ProgressBar.scss'
import Text from '@components/Text/Text'
import { TextTag } from '@enums/textTag'
import { VelvetSDK } from 'sdk'
import { remainingTimeForWatchingFormatter } from '@utils/helpers'
import { DocumentData } from 'firebase/firestore'
import classNames from 'classnames'

interface ProgressBarProps {
  data: DocumentData | null
  isItemInWatchingProgress?: boolean
  seasonInfo?: number
  episodeInfo?: number
  isActive?: boolean
  additionalInfoHero?: boolean
}

const ProgressBar = ({
  data,
  isItemInWatchingProgress,
  seasonInfo,
  episodeInfo,
  additionalInfoHero,
  isActive,
}: ProgressBarProps) => {
  const V = VelvetSDK.Vocabulary.vocabulary
  const progressTrack = remainingTimeForWatchingFormatter(data?.resourceDuration - data?.watchedDuration)
  const currentSeasonAndEpisode =
    seasonInfo !== undefined && episodeInfo !== undefined && `S${seasonInfo + 1}: E${episodeInfo + 1}`
  const width = data?.resourceDuration > 0 ? (data?.watchedDuration / data?.resourceDuration) * 100 : 0

  return (
    <>
      {isItemInWatchingProgress && data && additionalInfoHero && (
        <div className="progress">
          <div className="progress-bar-container">
            <div className="progress-bar">
              <div className="progress-bar-fill" style={{ width: `${width}%` }}></div>
            </div>
            <Text tag={TextTag.P} className="progress-bar-label">
              {progressTrack} {V.detailsSeriesTimeLessLabel}
            </Text>
          </div>
          {data?.title && (
            <Text tag={TextTag.P} className="progress-title">
              {currentSeasonAndEpisode} {data?.title}
            </Text>
          )}
        </div>
      )}
      {data && !additionalInfoHero && (
        <div className={classNames('progress-bar-absolute', { 'progress-bar-focus': isActive })}>
          <div className="progress-bar-active" style={{ width: `${width}%` }}></div>
        </div>
      )}
    </>
  )
}

export default ProgressBar
